import { useSyncExternalStore } from "react";

/** Live `matchMedia` result (false where matchMedia is unavailable). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (listener) => {
      if (typeof matchMedia !== "function") return () => undefined;
      const media = matchMedia(query);
      media.addEventListener("change", listener);
      return () => media.removeEventListener("change", listener);
    },
    () => typeof matchMedia === "function" && matchMedia(query).matches,
    () => false,
  );
}

/** Wide enough for the board's list + card side by side. */
export const WIDE_QUERY = "(min-width: 1024px)";

/** A touch screen: key hints are noise there, so screens offer buttons and say "tap" instead. */
export const TOUCH_QUERY = "(pointer: coarse)";

/** Wide enough for "Your day" as a third column beside the feed's list and card. */
export const RAIL_QUERY = "(min-width: 1280px)";
